<div #map [style.width]="width" [style.height]="height"></div>
